export enum ModalOrder {
  OFFICE_TNC_CONSENT_POPUP = 'office-tnc-consent-popup',
  ACCEPT_TERMS_POPUP = 'accept-terms-popup',
  TUTORIAL_POPUP = 'tutorial-popup',
  PAYMENT_METHOD_SUCCESS_POPUP = 'payment-method-success-popup',
  CARD_SUCCESS_POPUP = 'card-success-popup',
  BANK_SUCCESS_POPUP = 'bank-success-popup',
  SUSPENDED_POSTINGS_POPUP = 'suspended-postings-popup',
}

export const MODAL_ORDER_LIST = [
  ModalOrder.OFFICE_TNC_CONSENT_POPUP,
  ModalOrder.ACCEPT_TERMS_POPUP,
  ModalOrder.TUTORIAL_POPUP,
  ModalOrder.PAYMENT_METHOD_SUCCESS_POPUP,
  ModalOrder.CARD_SUCCESS_POPUP,
  ModalOrder.BANK_SUCCESS_POPUP,
  ModalOrder.SUSPENDED_POSTINGS_POPUP,
];
